import { Link } from "react-router-dom";

const points = [
  { icon: "ri-film-line", text: "聚焦影片本身的资讯、剧情与人物资料" },
  { icon: "ri-live-line", text: "持续跟进影片动态、影展与幕后进展" },
  { icon: "ri-book-open-line", text: "以章节化方式梳理完整的故事脉络" },
];

export default function SiteIntro() {
  return (
    <section className="bg-primary-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative">
            <div className="h-72 w-full overflow-hidden rounded-lg md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20cinematic%20still%20of%20a%20sunlit%20peach%20orchard%20path%20with%20soft%20golden%20light%20and%20gentle%20haze%2C%20artistic%20and%20atmospheric%20mood%2C%20warm%20peach%20and%20amber%20color%20grade%2C%20high%20detail&width=1200&height=900&seq=peach-intro-01&orientation=landscape"
                alt="蜜桃园的午后光影"
                title="蜜桃成熟时3D 影视资讯门户"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 hidden rounded-lg bg-background-50 px-5 py-4 shadow-sm md:block">
              <p className="font-heading text-2xl font-bold text-primary-700">2026</p>
              <p className="text-xs text-foreground-500">影片定档年份</p>
            </div>
          </div>

          <div>
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-600">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              ABOUT THE SITE
            </span>
            <h2 className="mb-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一个为影迷准备的影视资讯空间
            </h2>
            <p className="mb-6 text-sm leading-relaxed text-foreground-600 md:text-base">
              「蜜桃成熟时3D」影视资讯门户专注于呈现影片的最新动态、完整剧情与演员资料。我们希望把零散的信息整理成一条可以慢慢阅读的线索，让每一位影迷都能在这里，找到自己想了解的那部分故事。
            </p>
            <ul className="mb-8 space-y-3">
              {points.map((point) => (
                <li key={point.text} className="flex items-start gap-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600">
                    <i className={`${point.icon} text-base`}></i>
                  </span>
                  <span className="pt-1 text-sm text-foreground-700">{point.text}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                了解我们
              </Link>
              <Link
                to="/contact"
                className="whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}